export default "__VITE_ASSET__c8$UlGI6__"